import cn from "classnames";
import { useAppSelector } from "hooks/useAppSelector";
import { useTranslation } from "localization/localization";
import {
  getInvalidRequiredPalletFields,
  RequiredPalletField,
  selectOptions,
  selectPalletRowByGroupId,
  selectShowCargoValidation,
} from "store";
import { PalleteRow } from "./PalleteRow";
import s from "./PalletTable.module.scss";

export const PalletTable = ({ groupId }: { groupId: string }) => {
  const { t } = useTranslation();
  const { lengthUnits, weightUnits } = useAppSelector(selectOptions);
  const showValidation = useAppSelector(selectShowCargoValidation);
  const palletRow = useAppSelector(selectPalletRowByGroupId(groupId));

  const invalidColumns = new Set<RequiredPalletField>(
    showValidation && palletRow ? getInvalidRequiredPalletFields(palletRow) : []
  );
  const headerError = (field: RequiredPalletField) => invalidColumns.has(field);

  return (
    <div className={s.table}>
      <div className={s.header}>
        <div className={s.headerCell}>{t("Pallet type")}</div>
        <div className={cn(s.headerCell, headerError("length") && s.headerCellError)}>
          {t(`Length, ${lengthUnits}`)}
        </div>
        <div className={cn(s.headerCell, headerError("width") && s.headerCellError)}>{t(`Width, ${lengthUnits}`)}</div>
        <div className={cn(s.headerCell, headerError("height") && s.headerCellError)}>
          {t(`Height, ${lengthUnits}`)}
        </div>
        <div className={cn(s.headerCell, headerError("depth") && s.headerCellError)}>{t(`Depth, ${lengthUnits}`)}</div>
        <div className={cn(s.headerCell, headerError("maxWeight") && s.headerCellError)}>
          {t(`Max Weight, ${weightUnits}`)}
        </div>
        <div className={s.headerCell}>{t("Color")}</div>
      </div>
      <PalleteRow groupId={groupId} />
    </div>
  );
};
